<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form" >
        <a-form-item label="上级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-tree-select
            style="width: 100%"
            allow-clear
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="departmentTreeData"
            v-decorator="[
              'parent_category_id',
              {
                rules: [
                  { required: false, message: '' },
                ],
              },
            ]"
            placeholder="请选择"
          >
          </a-tree-select>
        </a-form-item>
        <a-form-item label="品类名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
        </a-form-item>
        <a-form-item label="品类编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="['part_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
        </a-form-item>
        <a-form-item label="完整编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-decorator="['code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
        </a-form-item>
        <a-form-item label="金蝶物料编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['jd_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:16, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
        </a-form-item>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { category_update, category_list } from '@/api/trade_category'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      loading: false,
      departmentTreeData: [],
      data: {}
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.loading = true
    this.loadCategory()
    category_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.loadEditInfo(list[0])
          this.data = list[0]
        }
      }).finally(() => {
        this.loading = false
    })
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          if (('' + values['parent_category_id']) === this.id) {
            this.$message.warning('上级不能选自己')
            return
          }
          category_update(values, this.id).then((res) => {
            this.handleGoBack()
            console.log(res, '修改成功')
          })
        }
      })
    },
    loadCategory (value) {
      category_list({ name: value, page: 1, page_size: 99999 }).then((res) => {
        const result = res.data.entries || []
        this.departmentTreeData = this.buildTree(this.transformCategories(result))
      }).finally(() => {
        this.$nextTick(() => {
          this.loadEditInfo(this.record)
        })
      })
    },
    loadEditInfo (data) {
      this.$nextTick(() => {
        const { form } = this
        console.log(`将加载 ${this} 信息到表单`)
        new Promise((resolve) => {
          setTimeout(resolve, 10)
        }).then(() => {
          if (data.parent_category_id === -1) {
            data.parent_category_id = undefined
          }
          if ((data.part_code === '' || data.part_code === undefined) && (data.code !== undefined && data.code.length > 3)) {
            data.part_code = data.code.substring(2)
          }
          const formData = pick(data, ['parent_category_id', 'name', 'code', 'part_code', 'jd_code'])
          console.log('formData', formData)
          form.setFieldsValue(formData)
        })
      })
    },
    transformCategories (categories) {
      return categories.map(category => ({
        title: category.name,
        value: category.id,
        key: category.id,
        parent_category_id: category.parent_category_id
      }))
    },
    buildTree (categories) {
      const idToNodeMap = {}
      const tree = []
      // 初始化每个节点
      categories.forEach(category => {
        idToNodeMap[category.key] = { ...category, children: [] }
      })
      // 构建树状结构
      categories.forEach(category => {
        const parentId = category.parent_category_id
        if (parentId === -1) {
          tree.push(idToNodeMap[category.key])
        } else {
          idToNodeMap[parentId].children.push(idToNodeMap[category.key])
        }
      })
      return tree
    }
  }
}
</script>
